module.exports = __webpack_public_path__ + "img/foto-ricardo.d4d47b6a.png";